import Admin from "@/views/Admin";
import Add from "@/views/Admin/Add";
import AddNews from "@/views/Admin/AddNews";
import AdminHome from "@/views/Admin/AdminHome";
import Auth from "@/views/Admin/Auth";
import Categories from "@/views/Admin/Categories";
import EditMission from "@/views/Admin/EditMission";
import Mission from "@/views/Admin/Mission";
import Login from "@/views/Login";
import Requests from "@/views/Admin/Requests";

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    children: [
      {
        path: "/",
        name: "admin-home",
        component: AdminHome,
      },
      {
        path: "add",
        name: "admin-add",
        component: Add,
      },
      {
        path: "mission",
        name: "admin-mission",
        component: Mission,
      },
      {
        path: "edit-mission",
        name: "admin-edit-mission",
        component: EditMission,
      },
      {
        path: "add-news",
        name: "admin-add-news",
        component: AddNews,
      },
      {
        path: "edit-news",
        name: "admin-edit-news",
        component: AddNews,
      },
      {
        path: "category",
        name: "admin-category",
        component: Categories,
      },
      {
        path: "auth",
        name: "admin-auth",
        component: Auth,
      },
      {
        path: "requests",
        name: "admin-requests",
        component: Requests,
      },
    ],
  },
];

export default routes;
